// fetch.js
import { useQuery,useMutation } from "@tanstack/react-query";
import axios from "axios";
import { config } from "./config";


// Centralized data fetching function using axios
const fetchData = async (url, baseUrl = config.serverURL) => {
  try {
    // Use baseUrl parameter to create the full URL dynamically
    const response = await axios.get(`${baseUrl}/${url}`,{withCredentials:true});
    // Check if the response data is an array
    if (Array.isArray(response.data)) {

      return response.data.length ===0 ? [] : response.data.map((product) => ({
        ...product,
      }));
    }
    // If response.data is an object (e.g., for a single product), return it as-is
    return {
      ...response.data,
    };
  } catch (error) {
    // throw new Error("Error fetching data");
    if (error.response) {
      // Handle server response errors (404, 500, etc.)
      throw new Error(error.response.data.message || "Error fetching data");
      
    } else if (error.request) {
      // Handle no response from server
      throw new Error("No response from server");
    } else {
      // Handle other unexpected errors
      throw new Error("An unexpected error occurred");
    }
  }
};

// Custom hook to fetch data
export const useFetch = (url, baseUrl) => {
  return useQuery([url], // Use the passed URL as the query key for caching
    
    () => fetchData(url, baseUrl), // Fetch data from the passed URL with optional baseUrl
   

  );
};

// Centralized data posting function using axios
const postData = async (url, data, baseUrl = config.serverURL) => {
 
  try {
    const response = await axios.post(`${baseUrl}/${url}`, data, {withCredentials: true,});
  
    return response.data; // Return response data from the server
  } catch (error) {
    // Check if the error has a response (i.e., it's from the server)
    const errorMessage = error.response?.data?.error || error.message;
    throw new Error(errorMessage); // Throw error message
  }
};

// Custom hook to POST data
export const usePost = (url) => {
  
  return useMutation(
    (newData) => postData(url, newData, config.serverURL), // Use the URL and new data to make the POST request
    {
      onSuccess: (data) => {
        console.log("Success:", data); // Handle success (e.g., show a success message)
        // If the response contains a JWT token, store it in localStorage
        if (data?.token) {
          //Cookies.set('authtoken', data.token, { expires: 365, secure: true, sameSite: 'Strict' });
          //axios.defaults.withCredentials = true; // Enable cookies in requests
          axios.defaults.headers['Authorization'] = `Bearer ${data.token}`; // Set token in Axios headers
        }
      },
      onError: (error) => {
        console.error("Error:", error); // Handle errors (e.g., show an error message)
      }
    }
  );
};
// Centralized data deletion function using axios
const deleteData = async (url, data, baseUrl = config.serverURL) => {
  try {
    const response = await axios.delete(`${baseUrl}/${url}`, {
      data, // Sending data in the body for DELETE request
      withCredentials: true, // Ensure the request includes cookies
    });

    return response.data; // Return response data from the server
  } catch (error) {
    // Check if the error has a response (i.e., it's from the server)
    const errorMessage = error.response?.data?.error || error.message;
    throw new Error(errorMessage); // Throw error message
  }
};

// Custom hook to DELETE data
export const useDelete = (url) => {
  return useMutation(
    (dataToDelete) => deleteData(url, dataToDelete, config.serverURL), // Use the URL and new data to make the DELETE request
    {
      onSuccess: (data) => {
        console.log("Success:", data); // Handle success (e.g., show a success message)
      },
      onError: (error) => {
        console.error("Error:", error); // Handle errors (e.g., show an error message)
      }
    }
  );
};


const useUpdate = (route, baseUrl) => {
  const mutation = useMutation(async (reqBody) => {
    const response = await axios.patch(`${baseUrl}/${route}`, reqBody, {
      withCredentials: true,
    });
    return response.data;
  });

  return mutation;
};

export default useUpdate;

